import { TranslateService } from "projects/shared/src/lib/services/translate.service";

export class AgGridUserGroupRoleSettings {

  constructor(private translate: TranslateService) { }

  public agGridProjectUserGroupRolesSettings = {
    rowModelType: 'infinite',
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: 'single',
    //rowDeselection: true,
    rowHeight: 65,
    enableRangeSelection: true,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 0,
    columnDefs: [
      { field: 'name', headerName: `${this.translate.data["SUBTITLEPROJECTUSERGROUPROLES"]}`, cellStyle: { color: '#303f6f' }, sortable: true, filter: true }
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  };

}